import React from "react";
import { ManageSupplier } from "../../components/Settings/Supplier/ManageSupplier";
import { ToastContainer } from "react-toastify";
export const ManageSupplierPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageSupplier/>
        </div>
      </div>
    </div>
  );
};
